import React from "react";
import { Navbar, Button } from "@nextui-org/react";
import { useLocation, Link } from "react-router-dom";
import { Logo } from "./logo.js";
import useStorage from "../storage/useLocalStorage.js";

export default function HeaderDev() {
  const location = useLocation();
  const [usersName = "", setUsersName] = useStorage("userName");
  const [developerKey = "", setDeveloperKey] = useStorage("developerKey");
  const [doingAction = false, setDoingAction] = useStorage("doingAction");
  const [userAuthenticated = false, setUserAuthenticated] =
    useStorage("userAuthenticated");

  const logoutUser = () => {
    setUserAuthenticated(false);
    setUsersName(false);
  };
  return (
    <div>
      <Navbar isBordered variant={"sticky"} height={85}>
        <Navbar.Brand>
          <Logo />
        </Navbar.Brand>
        <Navbar.Content hideIn="xs">
          {/* <Navbar.Link href="#">Home</Navbar.Link> */}
          <Navbar.Link>
            <Link
              style={{ color: location.pathname === "/" ? "blue" : "black" }}
              to="/"
            >
              Developers
            </Link>
          </Navbar.Link>
          <Navbar.Link>
            <Link
              style={{
                color:
                  location.pathname === "/dev/playground" ? "blue" : "black",
              }}
              to="/dev/playground"
            >
              Playground
            </Link>
          </Navbar.Link>
          <Navbar.Link>
            <Link
              style={{
                color: location.pathname === "/dev/logs" ? "blue" : "black",
              }}
              to="/dev/logs"
            >
              Logs
            </Link>
          </Navbar.Link>
          {/* <Navbar.Link
            href={`https://documenter.getpostman.com/view/26491751/2s93Xu1QVZ`}
            target="_blank"
          >
            Document
          </Navbar.Link> */}
        </Navbar.Content>
        <Navbar.Content>
          <div>
            <Navbar.Item color="inherit">{usersName || ""}</Navbar.Item>
            <Navbar.Item color="inherit">
              {`Dev Key: ${developerKey}` || ""}
            </Navbar.Item>
          </div>
          <Navbar.Item>
            <Button auto flat onClick={(e) => logoutUser()}>
              Log Out
            </Button>
          </Navbar.Item>
          {/* {doingAction === true && <Loading size="sm" />} */}
        </Navbar.Content>
      </Navbar>
    </div>
  );
}
